/**
 * BitMiner24 — Live Block Reward Updater
 * Single fetch per pageload (+ 5-min refresh). Patches all [data-bm-reward] spans.
 * Dispatches `bm:reward-loaded` event so other snippets can read full payload.
 */
(function () {
  if (window.__bmRewardLoaded) return;
  window.__bmRewardLoaded = true;

  var WORKER = 'https://bitminer24-solo-tracker.proud-dawn-de10.workers.dev';
  var COINGECKO = 'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=eur';
  var BLOCK_SUBSIDY_BTC = 3.125;

  // Number formatting follows the storefront language, not the shop's primary locale:
  // "3,125 BTC" and "170.000 €" read as three thousand and one hundred seventy in English.
  var LANG = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  var IS_DE = LANG === 'de';
  var GROUP = IS_DE ? '.' : ',';
  var DECIMAL = IS_DE ? ',' : '.';
  var APPROX = IS_DE ? 'ca. ' : 'approx. ';

  function fmt(n) { return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, GROUP); }
  function fmtThreshold(eur) { return fmt(Math.floor(eur / 10000) * 10000) + '+'; }
  function fmtRound5(eur) { return APPROX + fmt(Math.round(eur / 5000) * 5000); }
  function fmtBtcDe(btc) { return Number(btc).toFixed(3).replace('.', DECIMAL); }

  // Animated count-up via Motion FX when available, instant swap otherwise
  function setText(el, text) {
    if (window.BMFx && window.BMFx.tweenText) window.BMFx.tweenText(el, text);
    else if (el.textContent !== text) el.textContent = text;
  }

  function paint(btcText, eurExact, eurThreshold, eurRound5) {
    // Selectors: data-attributes (Liquid snippet) + class-based (JSON-templates strip data-*)
    var sel = '[data-bm-reward],.bm-reward-btc,.bm-reward-eur,.bm-reward-eur-exact,.bm-reward-eur-round5';
    var nodes = document.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var kind = el.getAttribute('data-bm-reward');
      var style = el.getAttribute('data-bm-style');
      if (!kind) {
        // Derive from class
        if (el.classList.contains('bm-reward-btc')) kind = 'btc';
        else if (el.classList.contains('bm-reward-eur-exact')) { kind = 'eur'; style = 'exact'; }
        else if (el.classList.contains('bm-reward-eur-round5')) { kind = 'eur'; style = 'round5'; }
        else if (el.classList.contains('bm-reward-eur')) { kind = 'eur'; style = style || 'threshold'; }
      }
      if (kind === 'btc' && btcText) setText(el, btcText);
      else if (kind === 'eur') {
        var s = style || 'threshold';
        var v = s === 'exact' ? eurExact : s === 'round5' ? eurRound5 : eurThreshold;
        if (v) setText(el, v);
      }
    }
  }

  function applyFromWorker(data) {
    var d = (data && data.display) || {};
    var jp = (data && data.jackpot) || {};
    var btcText = (IS_DE && d.btc_de) || (jp.btc != null ? fmtBtcDe(jp.btc) : null);
    var eurExact = (IS_DE && d.eur_exact_de) || (jp.eur != null ? fmt(jp.eur) : null);
    var eurThreshold = (IS_DE && d.eur_threshold_de) || (jp.eur != null ? fmtThreshold(jp.eur) : null);
    var eurRound5 = (IS_DE && d.eur_round5_de) || (jp.eur != null ? fmtRound5(jp.eur) : null);
    paint(btcText, eurExact, eurThreshold, eurRound5);
    window.bmRewardData = data;
    try { document.dispatchEvent(new CustomEvent('bm:reward-loaded', { detail: data })); } catch (e) {}
  }

  function applyFromPrice(eur) {
    var jpEur = BLOCK_SUBSIDY_BTC * eur;
    paint(fmtBtcDe(BLOCK_SUBSIDY_BTC), fmt(jpEur), fmtThreshold(jpEur), fmtRound5(jpEur));
  }

  function fetchJson(url, timeoutMs, onSuccess, onFail) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.timeout = timeoutMs || 6000;
    xhr.onload = function () {
      if (xhr.status === 200) {
        try { onSuccess(JSON.parse(xhr.responseText)); }
        catch (e) { if (onFail) onFail(); }
      } else if (onFail) onFail();
    };
    xhr.onerror = xhr.ontimeout = function () { if (onFail) onFail(); };
    xhr.send();
  }

  function load() {
    fetchJson(WORKER, 6000,
      function (data) { applyFromWorker(data); },
      function () {
        fetchJson(COINGECKO, 5000, function (data) {
          var eur = data && data.bitcoin && data.bitcoin.eur;
          if (eur) applyFromPrice(eur);
        }, null);
      }
    );
  }

  function start() { load(); setInterval(load, 300000); }
  window.bmRewardRefresh = load;

  // Re-apply cached data to freshly rendered DOM (e.g. cart drawer section
  // re-renders) without re-fetching or re-dispatching bm:reward-loaded.
  window.bmRewardRepaint = function () {
    var data = window.bmRewardData;
    if (!data) return;
    var d = data.display || {};
    var jp = data.jackpot || {};
    var btcText = (IS_DE && d.btc_de) || (jp.btc != null ? fmtBtcDe(jp.btc) : null);
    var eurExact = (IS_DE && d.eur_exact_de) || (jp.eur != null ? fmt(jp.eur) : null);
    var eurThreshold = (IS_DE && d.eur_threshold_de) || (jp.eur != null ? fmtThreshold(jp.eur) : null);
    var eurRound5 = (IS_DE && d.eur_round5_de) || (jp.eur != null ? fmtRound5(jp.eur) : null);
    paint(btcText, eurExact, eurThreshold, eurRound5);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
